<template>
     <div class="search_form">
        <div class="search_form_input">
            <a-input v-model:value="searchData.contractNum" placeholder="Поиск..." c class="search_form_input_item" @change="onChangeContractNum">
                <template #prefix>
                    <search-outlined style="color: #007BFF;"/>
                </template>
            </a-input>
        </div>
        <a-divider />
        <a-select 
            v-model:value="searchData.type_id" 
            placeholder="Выберите тип продукта" 
            :options="productTypeList"
            class="search_form_select"
            @change="onChangeProductType"
            allow-clear
        />
        <a-select 
            v-model:value="searchData.product" 
            placeholder="Выберите тип продукта" 
            :options="contractTypeList"
            class="search_form_select"
            @change="onChangeContractType"
            allow-clear
        />
        <a-select 
            v-model:value="searchData.status" 
            placeholder="Выберите статус" 
            :options="statusList"
            class="search_form_select"
            @change="onChangeStatus"
            allow-clear
        />
        <div class="search_form_date">
            <p>C</p>
            <a-config-provider :locale="ruRu">
                <a-input-group compact class="search_form_date_item" >
                    <a-input
                        style="width: 40px; text-align: center"
                        disabled
                    >
                        <template #prefix>
                            <calendar-outlined />
                        </template>
                    </a-input>
                        <a-date-picker 
                            format="DD.MM.YYYY"
                            show-today="false" 
                            :suffix-icon="null" 
                            v-model:value="searchData.start_date" 
                            style="width: calc(100% - 40px)" 
                            placeholder="Выберите дату" 
                            @change="onChangeStartDate"/>
                </a-input-group>
            </a-config-provider>

            <p>по</p>
            <a-config-provider :locale="ruRu">
                <a-input-group compact class="search_form_date_item">
                    <a-input
                        style="width: 40px; text-align: center"
                        disabled
                    >
                        <template #prefix>
                            <calendar-outlined />
                        </template>
                    </a-input>
                    <a-date-picker 
                        :suffix-icon="null" 
                        v-model:value="searchData.end_date" 
                        style="width: calc(100% - 40px)"  
                        placeholder="Выберите дату" 
                        @change="onChangeEndDate"
                        format="DD.MM.YYYY"
                    />
                </a-input-group>
            </a-config-provider>
        </div>
        <a-button @click="searchContractObject">Поиск</a-button>
    </div>
    <a-divider />
    <div class="personal_account_info">
        <div class="personal_account_info_left">
            <p>Всего обьектов: <span>{{ contractsObjectsList.length }}</span></p>
        </div>
        <div class="personal_account_info_right">
            <a-button @click="exportContracts">
                <img src="../../assets/images/downloadFile.svg" alt="">
                Выгрузить данные в отчет
            </a-button>
        </div>
    </div>
    <a-divider />
    <div class="personal_account_table">
        <a-table
            :columns="contractObjectColumns"
            :row-key="record => record.id"
            :data-source="contractsObjectsList"
            :loading="isLoadingContractsObjectsList"
            :scroll="{ x: 'max-content' }"

        >
            <template #bodyCell="{ column , record}">
                <template v-if="column.key === 'product'">
                    <div class="product_name_col">
                        <div class="product_name_line"></div>
                        <p>
                            {{ record.product }}
                        </p>
                    </div>
                </template>
                 <template v-else-if="column.dataIndex === 'insurance_premium'">
                    <p>
                        {{record.insurance_premium ? `${record.insurance_premium}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' '): ''}}
                    </p>
                </template>
                <template v-else-if="column.dataIndex === 'action'">
                    <button class="download_btn" @click="downloadFile(record)">
                        <download-outlined />
                        Скачать договор
                    </button>
                    <button class="open_btn" @click="openContractModal(record)">
                        Открыть
                    </button>
                </template>

            </template>
        </a-table>
    </div>
    <ContractObjectModal :openedContract="openedContract" :open="isOpenContractModal" @close="isOpenContractModal = !isOpenContractModal"/>
</template>

<script>
import { Tabs, Input, DatePicker, Divider, Button, Spin, Table, Select, ConfigProvider, TreeSelect} from 'ant-design-vue'
import ContractsTab from '@/components/personalAccount/ContractsTab.vue';
import ContractsObjectsTab from '@/components/personalAccount/ContractsObjectsTab.vue';
import ContractsPaymentsTab from '@/components/personalAccount/ContractsPaymentsTab.vue';
import ruRu from 'ant-design-vue/es/locale/ru_RU'
import {MinusCircleOutlined, SearchOutlined, CalendarOutlined, DownloadOutlined} from '@ant-design/icons-vue'
import axios from 'axios';
import { useToast } from 'vue-toastification'
import store from '@/store'
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/ru';
import 'dayjs/locale/ru';
import router from "@/router";
import ContractObjectModal from './ContractObjectModal.vue';
dayjs.locale('ru');
moment.locale('ru');
const toaster = useToast();
const contractObjectColumns =  [
{
  title: 'Наименование продукта',
  dataIndex: 'product',
  key: 'product',
  width: '13%'
},
{
  title: 'Номер договора',
  dataIndex: 'contract_number',
  key: 'contract_number',
},
{
  title: 'Гос.номер ТС',
  dataIndex: 'plate_number',
  key: 'plate_number',
  width: '7%'
},
{
  title: 'VIN-код',
  dataIndex: 'vin',
  key: 'vin',
  width: '10%'
},
{
  title: 'Дата начала договора',
  dataIndex: 'start_date',
  key: 'start_date',
  width: '10%'
},
{
  title: 'Дата окончания договора',
  dataIndex: 'end_date',
  key: 'end_date',
  width: '10%'
},
{
  title: 'Статус',
  dataIndex: 'status',
  key: 'status',
  width: '10%'
},
{
  title: 'Страховая премия',
  dataIndex: 'insurance_premium',
  key: 'insurance_premium',
  width: '8%'
},
{
  title: '',
  dataIndex: 'action',
  key: 'action',
},
];
const statusList = [
    {
        value: 'Действующий',
        label: "Действующий",
    },
    {
        value: 'Недействующий',
        label: "Недействующий",
    }
]
export default {
    props: {
        selectedCompanyId: {
            type: Number,
            default: null
        }
    },
    components: { 
        AInput: Input, 
        ADatePicker: DatePicker, 
        ADivider: Divider, 
        AButton: Button,
        ASpin: Spin, 
        ATabs: Tabs,
        ATabPane: Tabs.TabPane,
        ATable: Table,
        MinusCircleOutlined,
        SearchOutlined,
        CalendarOutlined,
        DownloadOutlined,
        ASelect: Select,
        AConfigProvider: ConfigProvider,
        ATreeSelect: TreeSelect,
        ContractsTab,
        ContractsObjectsTab,
        ContractsPaymentsTab,
        ContractObjectModal
    },  
    data() {
        return {
            ruRu,
            user: store.getters['auth/getUser'],
            activeKey: 'contracts',
            searchData: {
              search: null,
              type_id: 1,
              product: null,
              start_date: null,
              end_date: null,
              status: null,
            },
            contractObjectColumns,
            productTypeList: [],
            contractTypeList: [],
            contractsObjectsList: [],
            isLoadingContractsObjectsList: false,
            isOpenContractModal: false,
            openedContract: null,
            statusList
        }
    }, 
    mounted() { 
      if(localStorage.getItem("auth_token")){
           axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("auth_token")}`
      }
      this.isLoadingContractList = true
      this.isLoadingContractsObjectsList = true
      console.log(this.selectedCompanyId);
      if(this.selectedCompanyId){
        this.getProductList()
      }
      // this.getProductList()
      //  this.getQuestionnaireData(this.$route.params.id.split('-').join(''))
      //  this.getAllDicties()
    },
    methods: {
      getContractsObject(data){
          axios.get(`/V1/my-contracts/objects?company_id=${this.selectedCompanyId}`, {params: data}).then(res => {
              this.contractsObjectsList = res.data.data.contracts_with_objects;
              this.isLoadingContractsObjectsList = false
          }).catch(error => {
              console.log(error);
          })
      },
      getProductList(){
          axios.get(`/V1/my-contracts/type-products?company_id=${this.selectedCompanyId}`).then(res => {
              this.productTypeList = res.data.data.types.map(item => {
                  return {
                      label: item.label,
                      value: item.id,
                      children: item.products.map(product => {
                          return {
                              label: product,
                              value: product,
                          }
                      })
                  }
              });
              this.contractTypeList =  res.data.data.types.filter(item => item.id === 1)[0].products.map(item => {
                  return {
                      label: item,
                      value: item
                  }
              })
              if(this.contractTypeList.length === 1){
                  this.searchData.product = this.contractTypeList[0].value
              }
              this.getContractsObject({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
          }).catch(error => {
              console.log(error);
              if(error.status === 401){
                  store.dispatch('auth/logoutTokenUnactive')
                  router.push('/')
              }
              
          })
      },
      openContractModal(record){
          this.isOpenContractModal = true
          this.openedContract = record
      },
      onChangeContractNum(e){
          this.searchData.search = e.target.value
      },
      onChangeProductType(e){
          this.searchData.product_type = e
      },
      onChangeContractType(e){
          this.searchData.product = e
      },
      onChangeStartDate(e){
          this.searchData.start_date = e
      },
      onChangeEndDate(e){
          this.searchData.end_date = e
      },
      onChangeStatus(e){
        this.searchData.status = e
      },
      searchContractObject(){
          this.getContractsObject({...this.searchData, start_date: this.searchData.start_date? dayjs(this.searchData.start_date).format('DD.MM.YYYY') : null, end_date: this.searchData.end_date ? dayjs(this.searchData.end_date).format('DD.MM.YYYY'): null})
      },
      async downloadFile(record){
          try{
              const response = await axios.get(record.file_path, {
                  responseType: 'blob', 
              })
              const blob = new Blob([response.data])
              const downloadUrl = window.URL.createObjectURL(blob)

              const link = document.createElement('a')
              link.href = downloadUrl
              link.download = `${record.contract_number}.pdf`
              document.body.appendChild(link)
              link.click()
              link.remove()

              window.URL.revokeObjectURL(downloadUrl)
          }catch(error){
              console.log(error);
              
          }
      },
      async exportContracts(){
          try{
            const response = await axios.post(`/V1/my-contracts/export?company_id=${this.selectedCompanyId}`, {ids: this.contractsObjectsList.map(contract => contract.contract_id), contract_type: this.searchData.type_id}, {responseType: 'blob'})
            const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
            const url = window.URL.createObjectURL(blob);
            const disposition = response.headers['content-disposition'];
            let filename = 'contracts.xlsx'; 
            if (disposition && disposition.includes('filename=')) {
                const filenameRegex = /filename\*=utf-8''([^;]+)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = decodeURIComponent(matches[1]);
                } else {
                    // Если нет filename*=, пробуем обычный filename=
                    const filenameSimpleRegex = /filename="?([^"]+)"?/;
                    const simpleMatches = filenameSimpleRegex.exec(disposition);
                    if (simpleMatches != null && simpleMatches[1]) {
                        filename = simpleMatches[1];
                    }
                }
            }
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Название файла
            document.body.appendChild(link);
            link.click();

            link.remove(); // Очистка
            window.URL.revokeObjectURL(url)
          }catch(error){
              let message;
              if (axios.isAxiosError(error) && error.response) {
                  message = error.response.data.message;
              } else {
                  message = String(error);
              }
              toaster.error(message, {
                  position: "top-right"
              })
          }
      }
    },
    watch: {
        selectedCompanyId(newVal){
            if(newVal){
                this.getProductList()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
        font-family: $family;
        font-style: normal;
        font-weight: $weight;
        font-size: $size;
        line-height: $lheight;
        color: $color;
    }
    @mixin mobile {
        @media(min-width: 320px) and (max-width: 425px) {
            @content;
        }
    }
    @mixin tablet {
        @media(min-width: 425px) and (max-width: 767px) {
            @content;
        }
    }
    @mixin tablet-1024 {
        @media(min-width: 767px) and (max-width: 1024px) {
            @content;
        }
    }
    @mixin desktop {
        @media(min-width: 1024px) and (max-width: 1440px) {
            @content;
        }
    }
    @mixin desktop-max {
        @media(min-width: 1620px) and (max-width: 2560px) {
            @content;
        }
    }
    .col_p{
        margin-bottom: 0;
    }
  .personal_account{
      padding: 30px 0;
      &_tabel{
        contain: layout
      }
      &_title{
          @include fontStyle(Roboto, normal, 500, 24px, 31px, #373737);
          text-align: center;
      }
      &_desc{
          @include fontStyle(Roboto, normal, 400, 22px, 31px, #909090);
          text-align: center;
          span{
              @include fontStyle(Roboto, normal, 400, 22px, 31px, #373737);
          }
      }
      &_info{
          @include fontStyle(Roboto, normal, 400, 24px, 31px, #373737);
          display: flex;
          justify-content: space-between;
          align-items: center;
          &_left{
              width: 30%;
              @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
              &_select{
                  width: 100%;
                  height: 50px;
              }
          }
          &_right{
              button{
                  @include fontStyle(Roboto, normal, 400, 16px, 31px, #373737);
                  padding: 4px 20px;
                  height: 55px;
                  display: flex;
                  align-items: center;
                  img{
                      width: 24px;
                      margin-right: 10px;
                  }
              }
          }
      }
  }
  ::v-deep(.personal_account_info_left){
      .ant-select-selector{
          height: 50px;
          input{
              height: 50px;
          }
          .ant-select-selection-placeholder{
              height: 50px;
              display: flex;
              align-items: center;
          }
      }
  }
  .product_name_col{
      display: flex;
      gap: 10px;
      align-items: center;
  }
  .product_name_line{
      height: 38px;
      width: 5px;
      background: #007BFF;
      border-radius: 3px;
  }
  .download_btn, .open_btn{
      background-color: #fff;
      padding: 4px 8px;
      border: 2px solid #F5F5F5;
      border-radius: 4px;
      cursor: pointer;
  }
  .download_btn{
      margin-right: 15px;
      span{
          color: #007BFF;
          font-size: 18px;
      }
  }
  .search_form{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      &_input{
          width: 100%;
      }
      &_date{
          display: flex;
          width: 38%;
          justify-content: space-between;
          height: 50px;
          align-items: center;
          gap: 15px;
          margin-top: 20px;
          p{
              @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
          }
          &_item{
              background: #fff;
              border-radius: 8px;
              width: 100%;
              span{
                  background: #fff;
                  color: #007BFF;
                  border: none;
                  font-size: 18px;
              }
              .ant-picker{
                  background: #fff;
                  border: none;
                  height: 50px;
              }
              .ant-picker-focused{
                  box-shadow: none;
              }
          }
      }
      &_select{
          width: 31%;
          height: 50px;
      }
      button{
          @include fontStyle(Roboto, normal, 400, 18px, 31px, #373737);
          height: 50px !important;
          border: none;
          background-color: #007BFF;
          color: #fff;
          width: 19%;
          margin-top: 20px;
      }
  }
  ::v-deep(.search_form){
      .search_form_input_item{
          height: 50px;
          border: none;
          .anticon-search{
              font-size: 18px;
          }
      }
      .search_form_input_item:focus{
          box-shadow: none;
      }
      .search_form_select .ant-select-selector{
          border: none;
          height: 50px;
          input{
              padding: 24px 0;
              display: flex;
              align-items: center;
          }
          .ant-select-selection-placeholder{
              display: flex;
              align-items: center;
          }
          .ant-select-selection-item{
              display: flex;
              align-items: center;
          }
      }
  }
  ::v-deep(.ant-tabs){
      .ant-tabs-nav-list{
          background: #F4F4F8 !important;
          border-radius: 8px;
          width: 100%;
          justify-content: space-between;
          padding: 15px 25px;
          .ant-tabs-tab-active{
              background: white !important;
          }
          .ant-tabs-tab{
              display: flex;
              justify-content: center;
              width: 30%;
              border: none;
              background: none;
              div{
                  font-size: 22px;
                  color: #373737;
                  border-radius: 8px;
                  padding: 7px 0;
              }
          }
      }
      .ant-tabs-content-holder{
          margin-top: 20px;
          .ant-tabs-tabpane{
              background: #F4F4F8 !important;
              border-radius: 8px;
          }
      }
  }
  .card-container p {
      margin: 0;
  }
  .ant-tabs-nav-wrap{
     
  }
  .card-container > .ant-tabs-card .ant-tabs-content {
      height: 120px;
      margin-top: -16px;
  }
  .card-container > .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
      padding: 16px;
      background: #fff;
  }
  .card-container > .ant-tabs-card > .ant-tabs-nav::before {
      display: none;
  }
  .card-container > .ant-tabs-card .ant-tabs-tab,
  [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab {
      background: transparent;
      border-color: transparent;
  }
  .card-container > .ant-tabs-card .ant-tabs-tab-active,
  [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab-active {
      background: #fff;
      border-color: #fff;
  }
  #components-tabs-demo-card-top .code-box-demo {
      padding: 24px;
      overflow: hidden;
      background: #f5f5f5;
  }
</style>

